import React, { useEffect } from "react";
import IconComponent from "../Icons/IconComponent";

const Thumbnail = ({ onClick, href }) => {
    return (
        <div style={{
            width: "48px",
            height: "48px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "6px",
            border: "1px solid var(--grey-light)",
            background: href ? "url(" + href + ") lightgray 50% / cover no-repeat" : "#F7F7F7",
            cursor: onClick ? "pointer" : "default"
        }}
        onClick={onClick}>
        </div>
    );
};

export default Thumbnail;
